import http from '../../utils/fetch';
export default {
    baseurl: '/api/swyl/v1/productChineseEnglish',

    page(query){
        return http({
            url: this.baseurl+'/selectPage',
            method: 'post',
            params: query
        });
    },

    updateById(f){
        return http({
            url: this.baseurl+'/updateById',
            method: 'post',
            params: f
        });
    },
    insert(f){
        return http({
            url: this.baseurl+'/insert',
            method: 'post',
            params: f
        });
    },

    deleteById(f){
        return http({
            url: this.baseurl+'/deleteById',
            method: 'post',
            params: f
        });
    },
    checkByMaterialCode(f){
        return http({
            url: this.baseurl+'/checkByMaterialCode',
            method: 'post',
            params: f
        });
    }


}